import { cn } from "@/utils/format";

export function Switch({
  checked,
  onChange,
  disabled,
  id,
  label,
  description,
}: {
  checked: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  id?: string;
  label?: string;
  description?: string;
}) {
  const switchId = id ?? label?.toLowerCase().replace(/\s+/g, "-");

  return (
    <div className={cn("switch-row", disabled && "switch-row--disabled")}>
      {(label || description) && (
        <div className="switch-row__copy">
          {label ? (
            <label className="switch-row__label" htmlFor={switchId}>
              {label}
            </label>
          ) : null}
          {description ? <p className="switch-row__desc">{description}</p> : null}
        </div>
      )}
      <button
        id={switchId}
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={label}
        disabled={disabled}
        className={cn("switch", checked && "switch--on")}
        onClick={() => onChange(!checked)}
      >
        <span className="switch__thumb" aria-hidden />
      </button>
    </div>
  );
}
